import _ from 'lodash'

import i18n from 'modules/core/lib/i18n'

export function normalizeText(text: string): string {
  return _.toLower(_.deburr(text))
}

export function matchText(search: string, text: string): boolean {
  const cleanText = normalizeText(text)
  const cleanSearch = normalizeText(search)

  return cleanText.includes(cleanSearch)
}

export function joinAsSentence(parts: string[]): string {
  if (parts.length < 2) return parts[0] ?? ''

  const initial = parts.slice(0, parts.length - 1).join(', ')

  const last = parts.slice(-1)

  return i18n.t('common.and', {
    initial,
    last,
  })
}
